import React from "react";

const LogoHeader = ({
  logoSrc,
  altText,
  mainLabel,
  subLabel,
  description,
  rightLogoSrc,
  styles = {}, // accept optional styles prop
}) => {
  // Define default styles
  const defaultStyles = {
    container: {
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      justifyContent: "center",
      alignItems: "center",
      marginTop: "1rem",
      gap: "0.5rem",
    },
    leftLogo: {
      maxWidth: "100px",
      maxHeight: "80px",
    },
    centerText: {
      borderBottom: "2px solid #333",
      paddingBottom: "5px",
      margin: 0,
    },
    subLabel: {
      fontFamily: "sans-serif",
      margin: 0,
    },
    labelContainer: {
      display: "flex",
      flexDirection: "column",
      textAlign: "center",
      padding: "5px",
    },
    description: {
      fontSize: "13px",
    },
    rightLogo: {
      maxWidth: "115px",
      maxHeight: "100px",
    },
  };

  // Merge passed styles with default styles
  const {
    container = defaultStyles.container,
    leftLogo = defaultStyles.leftLogo,
    centerText = defaultStyles.centerText,
    subLabelStyle = defaultStyles.subLabel,
    labelContainer = defaultStyles.labelContainer,
    description: descriptionStyle = defaultStyles.description,
    rightLogo = defaultStyles.rightLogo,
  } = styles;

  return (
    <div
      className="d-flex flex-column flex-md-row justify-content-center align-items-center mt-4 gap-2"
      style={container}
    >
      <img src={logoSrc} alt={altText} className="img-fluid" style={leftLogo} />
      <div
        className="d-flex flex-column text-center text-md-start"
        style={labelContainer}
      >
        <p className="m-0 text-center" style={centerText}>
          {mainLabel}
        </p>
        <h5 className="m-0" style={subLabelStyle}>
          <b>{subLabel}</b>
        </h5>
        <p className="m-0 text-center" style={descriptionStyle}>
          {description}
        </p>
      </div>
      <img
        src={rightLogoSrc}
        alt={altText}
        className="img-fluid"
        style={rightLogo}
      />
    </div>
  );
};

export default LogoHeader;
